const shopFilters = {
    ajaxUrl: typeof window.settings !== 'undefined' ? window.settings.ajax_url : '/wp-admin/admin-ajax.php',
    isLoading: false,
    selectedFilters: [],
    priceMin: '',
    priceMax: '',
    category: '',
    orderby: '',
    paged: 1,

    init() {
        this.cacheElements();
        this.getInitialState();
        this.toggleFilters();
        this.sidebarToggle();
        this.bindFilterLinks();
        this.bindActiveFilterRemoval();
        this.bindPriceFilter();
        this.bindSorting();
        this.bindPaginationClicks();
        this.bindFeaturedCategoriesDrag();
    },

    bindFeaturedCategoriesDrag() {
        const slider = document.querySelector('.shop-page__featured-grid');
        if (!slider) {
            return;
        }

        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;
        let moved = false;

        slider.querySelectorAll('img, a').forEach((el) => {
            el.setAttribute('draggable', 'false');
        });
        slider.addEventListener('dragstart', (e) => e.preventDefault());

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            moved = false;
            slider.classList.add('is-dragging');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
            e.preventDefault();
        });

        const stopDragging = () => {
            isDown = false;
            slider.classList.remove('is-dragging');
        };

        slider.addEventListener('mouseleave', stopDragging);
        slider.addEventListener('mouseup', stopDragging);

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) {
                return;
            }
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = x - startX;
            if (Math.abs(walk) > 5) {
                moved = true;
            }
            slider.scrollLeft = scrollLeft - walk;
        });

        slider.addEventListener('click', (e) => {
            if (moved) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, true);
    },

    cacheElements() {
        this.productsContainer = document.querySelector('.shop-page__main .products, .shop-page__main .no-products, .shop-page__main .shop-page__no-filters');
        this.mainContainer = document.querySelector('.shop-page__main');
        this.activeFiltersContainer = document.querySelector('.shop-page__active-filters');
        this.paginationContainer = document.querySelector('.woocommerce-pagination');
    },

    getInitialState() {
        const urlParams = new URLSearchParams(window.location.search);

        const filterParams = urlParams.getAll('product_filter[]');
        if (filterParams.length > 0) {
            this.selectedFilters = filterParams;
        } else {
            const singleFilter = urlParams.get('product_filter');
            if (singleFilter) {
                this.selectedFilters = [singleFilter];
            }
        }

        const checkedFilters = document.querySelectorAll('.shop-filter__input-hidden:checked');
        if (checkedFilters.length > 0 && this.selectedFilters.length === 0) {
            checkedFilters.forEach(checkbox => {
                if (checkbox.value && !this.selectedFilters.includes(checkbox.value)) {
                    this.selectedFilters.push(checkbox.value);
                }
            });
        }

        this.priceMin = urlParams.get('min_price') || '';
        this.priceMax = urlParams.get('max_price') || '';

        const categorySlug = document.querySelector('[data-category-slug]');
        if (categorySlug) {
            this.category = categorySlug.dataset.categorySlug;
        }

        this.orderby = urlParams.get('orderby') || '';

        this.paged = parseInt(urlParams.get('paged')) || 1;
    },

    toggleFilters() {
        const filterHeaders = document.querySelectorAll('[data-toggle-filter]');

        filterHeaders.forEach(header => {
            header.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const filter = header.closest('.shop-filter');
                if (filter) {
                    filter.classList.toggle('is-open');
                }
            });
        });
    },

    sidebarToggle() {
        const toggleBtn = document.querySelector('[data-toggle-filters]');
        const sidebar = document.querySelector('.shop-page__sidebar');
        const overlay = document.querySelector('.shop-page__sidebar-overlay');
        const closeButtons = document.querySelectorAll('[data-close-filters]');
        const toggleText = toggleBtn ? toggleBtn.querySelector('span') : null;
        const showText = toggleBtn ? toggleBtn.dataset.showText || 'Pokaż filtry' : '';
        const hideText = toggleBtn ? toggleBtn.dataset.hideText || 'Ukryj filtry' : '';

        if (!sidebar) return;

        const openSidebar = () => {
            sidebar.classList.add('is-open');
            if (overlay) overlay.classList.add('is-open');
            if (toggleText) toggleText.textContent = hideText;
            document.body.style.overflow = 'hidden';
        };

        const closeSidebar = () => {
            sidebar.classList.remove('is-open');
            if (overlay) overlay.classList.remove('is-open');
            if (toggleText) toggleText.textContent = showText;
            document.body.style.overflow = '';
        };

        if (toggleBtn) {
            toggleBtn.addEventListener('click', (e) => {
                e.preventDefault();
                if (sidebar.classList.contains('is-open')) {
                    closeSidebar();
                } else {
                    openSidebar();
                }
            });
        }

        closeButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                closeSidebar();
            });
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
                closeSidebar();
            }
        });
    },

    bindFilterLinks() {
        document.addEventListener('click', (e) => {
            const filterLink = e.target.closest('.shop-filter__link');
            if (!filterLink) return;

            e.preventDefault();

            const filterItem = filterLink.closest('.shop-filter__item');
            const checkbox = filterItem?.querySelector('input[type="checkbox"]');
            const filterSlug = checkbox?.value;
            if (!filterSlug) return;

            const filterName = filterLink.querySelector('.shop-filter__text')?.textContent || filterSlug;

            const filterIndex = this.selectedFilters.indexOf(filterSlug);
            if (filterIndex > -1) {
                this.selectedFilters.splice(filterIndex, 1);
                filterLink.classList.remove('shop-filter__link--active');
                this.removeActiveFilterTag(filterSlug);
            } else {
                this.selectedFilters.push(filterSlug);
                filterLink.classList.add('shop-filter__link--active');
                this.addActiveFilterTag(filterSlug, filterName);
            }

            if (checkbox) {
                checkbox.checked = !checkbox.checked;
            }

            this.paged = 1;

            this.filterProducts();
        });
    },

    addActiveFilterTag(filterSlug, filterName) {
        if (!this.activeFiltersContainer) {
            const categoryTop = document.querySelector('.shop-page__category-top');
            if (categoryTop) {
                const container = document.createElement('div');
                container.className = 'shop-page__active-filters';
                categoryTop.insertAdjacentElement('afterend', container);
                this.activeFiltersContainer = container;
            } else {
                const mainContainer = document.querySelector('.shop-page__main');
                if (mainContainer) {
                    const container = document.createElement('div');
                    container.className = 'shop-page__active-filters';
                    mainContainer.insertAdjacentElement('afterbegin', container);
                    this.activeFiltersContainer = container;
                }
            }
        }

        if (!this.activeFiltersContainer) return;

        if (this.activeFiltersContainer.querySelector(`[data-filter="${filterSlug}"]`)) return;

        const tag = document.createElement('span');
        tag.className = 'shop-page__filter-tag';
        tag.dataset.filter = filterSlug;
        tag.innerHTML = `${filterName}<span class="shop-page__filter-tag-remove" data-remove-filter="${filterSlug}">&times;</span>`;

        this.activeFiltersContainer.appendChild(tag);
    },

    removeActiveFilterTag(filterSlug) {
        if (!this.activeFiltersContainer) return;

        const tag = this.activeFiltersContainer.querySelector(`[data-filter="${filterSlug}"]`);
        if (tag) {
            tag.remove();
        }

        if (this.activeFiltersContainer.children.length === 0) {
            this.activeFiltersContainer.remove();
            this.activeFiltersContainer = null;
        }
    },

    bindActiveFilterRemoval() {
        document.addEventListener('click', (e) => {
            const removeFilter = e.target.closest('[data-remove-filter]');
            if (removeFilter) {
                e.preventDefault();
                const filterSlug = removeFilter.dataset.removeFilter;

                this.removeActiveFilterTag(filterSlug);

                const filterIndex = this.selectedFilters.indexOf(filterSlug);
                if (filterIndex > -1) {
                    this.selectedFilters.splice(filterIndex, 1);
                }

                const checkbox = document.querySelector(`input[type="checkbox"][value="${filterSlug}"]`);
                if (checkbox) {
                    checkbox.checked = false;
                    const filterLink = checkbox.closest('.shop-filter__item')?.querySelector('.shop-filter__link');
                    if (filterLink) {
                        filterLink.classList.remove('shop-filter__link--active');
                    }
                }

                this.paged = 1;

                this.filterProducts();
                return;
            }

            const removePrice = e.target.closest('[data-remove-price]');
            if (removePrice) {
                e.preventDefault();

                const priceTag = removePrice.closest('.shop-page__filter-tag--price');
                if (priceTag) priceTag.remove();

                this.priceMin = '';
                this.priceMax = '';

                const minPriceInput = document.getElementById('min_price');
                const maxPriceInput = document.getElementById('max_price');
                if (minPriceInput) minPriceInput.value = '';
                if (maxPriceInput) maxPriceInput.value = '';

                this.paged = 1;

                this.filterProducts();
            }
        });
    },

    bindPriceFilter() {
        const minPriceInput = document.getElementById('min_price');
        const maxPriceInput = document.getElementById('max_price');

        if (!minPriceInput || !maxPriceInput) return;

        const checkAndFilter = () => {
            const minVal = minPriceInput.value.trim();
            const maxVal = maxPriceInput.value.trim();

            if (minVal !== '' && maxVal !== '') {
                this.priceMin = minVal;
                this.priceMax = maxVal;

                this.addPriceFilterTag(minVal, maxVal);

                this.paged = 1;

                this.filterProducts();
            }
        };

        let debounceTimer;
        const handleInput = () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(checkAndFilter, 500);
        };

        minPriceInput.addEventListener('input', handleInput);
        maxPriceInput.addEventListener('input', handleInput);

        const handleEnter = (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                clearTimeout(debounceTimer);
                checkAndFilter();
            }
        };

        minPriceInput.addEventListener('keydown', handleEnter);
        maxPriceInput.addEventListener('keydown', handleEnter);
    },

    addPriceFilterTag(minPrice, maxPrice) {
        const existingPriceTag = document.querySelector('.shop-page__filter-tag--price');
        if (existingPriceTag) existingPriceTag.remove();

        if (!this.activeFiltersContainer) {
            const categoryTop = document.querySelector('.shop-page__category-top');
            if (categoryTop) {
                const container = document.createElement('div');
                container.className = 'shop-page__active-filters';
                categoryTop.insertAdjacentElement('afterend', container);
                this.activeFiltersContainer = container;
            } else {
                const mainContainer = document.querySelector('.shop-page__main');
                if (mainContainer) {
                    const container = document.createElement('div');
                    container.className = 'shop-page__active-filters';
                    mainContainer.insertAdjacentElement('afterbegin', container);
                    this.activeFiltersContainer = container;
                }
            }
        }

        if (!this.activeFiltersContainer) return;

        let currencySymbol = 'zł';
        if (typeof woocommerce_params !== 'undefined' && woocommerce_params.currency_symbol) {
            currencySymbol = woocommerce_params.currency_symbol;
        } else if (typeof settings !== 'undefined' && settings.currency_symbol) {
            currencySymbol = settings.currency_symbol;
        }

        const priceText = `${minPrice} - ${maxPrice} ${currencySymbol}`;

        const tag = document.createElement('span');
        tag.className = 'shop-page__filter-tag shop-page__filter-tag--price';
        tag.dataset.priceFilter = '';
        tag.innerHTML = `${priceText}<span class="shop-page__filter-tag-remove" data-remove-price>&times;</span>`;

        this.activeFiltersContainer.appendChild(tag);
    },

    bindSorting() {
        const sortingSelect = document.querySelector('.shop-page__sorting .orderby');
        const sortingValue = document.querySelector('[data-sorting-value]');

        if (!sortingSelect) return;

        sortingSelect.addEventListener('change', (e) => {
            this.orderby = e.target.value;
            this.paged = 1;

            if (sortingValue) {
                const selectedOption = sortingSelect.options[sortingSelect.selectedIndex];
                sortingValue.textContent = selectedOption.text;
            }

            this.filterProducts();
        });
    },

    filterProducts() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.showLoader();

        const formData = new FormData();
        formData.append('action', 'ajax_filter_products');

        if (typeof window.settings !== 'undefined' && window.settings.lang) {
            formData.append('lang', window.settings.lang);
        }

        this.selectedFilters.forEach(filter => {
            formData.append('product_filter[]', filter);
        });

        if (this.priceMin) formData.append('min_price', this.priceMin);
        if (this.priceMax) formData.append('max_price', this.priceMax);

        if (!this.category) {
            const categorySlugEl = document.querySelector('[data-category-slug]');
            if (categorySlugEl && categorySlugEl.dataset.categorySlug) {
                this.category = categorySlugEl.dataset.categorySlug;
            }
        }
        if (this.category) formData.append('category', this.category);

        if (this.orderby) formData.append('orderby', this.orderby);

        formData.append('paged', this.paged);

        fetch(this.ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                this.updateProducts(data.data);
                this.updateUrl();
            }
        })
        .catch(error => {
            console.error('Filter error:', error);
        })
        .finally(() => {
            this.isLoading = false;
            this.hideLoader();
        });
    },

    updateProducts(data) {
        if (data.products_html) {
            const temp = document.createElement('div');
            temp.innerHTML = data.products_html;

            const results = temp.querySelector('.products') || temp.firstElementChild;
            const sameGrid = this.productsContainer
                && this.productsContainer.classList.contains('products')
                && results
                && results.classList.contains('products');

            if (sameGrid) {
                this.productsContainer.innerHTML = results.innerHTML;
            } else if (results && this.productsContainer) {
                this.productsContainer.replaceWith(results);
                this.productsContainer = results;
            } else if (results && this.mainContainer) {
                this.mainContainer.appendChild(results);
                this.productsContainer = results;
            }
        }

        this.activeFiltersContainer = document.querySelector('.shop-page__active-filters');

        if (this.paginationContainer && data.pagination_html) {
            this.paginationContainer.outerHTML = data.pagination_html;
            this.paginationContainer = document.querySelector('.woocommerce-pagination');
        } else if (data.pagination_html) {
            if (this.productsContainer) {
                this.productsContainer.insertAdjacentHTML('afterend', data.pagination_html);
                this.paginationContainer = document.querySelector('.woocommerce-pagination');
            }
        } else if (this.paginationContainer) {
            this.paginationContainer.remove();
            this.paginationContainer = null;
        }

        if (this.mainContainer) {
            this.mainContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    },

    updateUrl() {
        const url = new URL(window.location.href);

        url.searchParams.delete('product_filter');
        url.searchParams.delete('product_filter[]');
        url.searchParams.delete('min_price');
        url.searchParams.delete('max_price');
        url.searchParams.delete('paged');

        this.selectedFilters.forEach(filter => {
            url.searchParams.append('product_filter[]', filter);
        });

        if (this.priceMin) url.searchParams.set('min_price', this.priceMin);
        if (this.priceMax) url.searchParams.set('max_price', this.priceMax);

        if (this.orderby) url.searchParams.set('orderby', this.orderby);

        if (this.paged > 1) url.searchParams.set('paged', this.paged);

        window.history.pushState({}, '', url.toString());
    },

    bindPaginationClicks() {
        document.addEventListener('click', (e) => {
            const pageLink = e.target.closest('.woocommerce-pagination [data-page]');
            if (!pageLink) return;
            if (pageLink.classList.contains('is-disabled') || pageLink.classList.contains('is-active')) return;

            e.preventDefault();

            const page = parseInt(pageLink.dataset.page, 10);
            if (!page || isNaN(page)) return;

            this.paged = page;
            this.filterProducts();
        });
    },

    showLoader() {
        if (this.productsContainer) {
            this.productsContainer.classList.add('is-loading');

            if (!this.productsContainer.querySelector('.shop-loader')) {
                const loader = document.createElement('div');
                loader.className = 'shop-loader';
                loader.innerHTML = '<div class="shop-loader__spinner"></div>';
                this.productsContainer.appendChild(loader);
            }
        }
    },

    hideLoader() {
        if (this.productsContainer) {
            this.productsContainer.classList.remove('is-loading');
            const loader = this.productsContainer.querySelector('.shop-loader');
            if (loader) {
                loader.remove();
            }
        }
    }
};

export default shopFilters;
